import React from "react";
import { useHistory } from "react-router-dom";
import * as S from "./styles";
import { CaveatType } from "interfaces/caveat-type";
import { useTranslation, usePermissions } from "hooks";
import { translations } from "./translations";

type GridCaveatTypesProps = {
  caveatTypes: CaveatType[] | Record<string, any>[];
};

type ItemProps = {
  caveatType: CaveatType | Record<string, any>;
};

const Item: React.FC<ItemProps> = ({ caveatType }) => {
  const history = useHistory();
  const { checkUserPermission } = usePermissions();
  const havePermission = checkUserPermission("editCaveatType");
  return (
    <S.ItemContainer
      onClick={() =>
        havePermission && history.push(`/settings/caveat-type/${caveatType.id}`)
      }
    >
      <S.ItemContent pointer={havePermission}>
        <S.ItemValue>{caveatType.id}</S.ItemValue>
        <S.ItemValue>{caveatType.name}</S.ItemValue>
        {havePermission && (
          <S.ButtonDetail>
            <S.IconDetail />
          </S.ButtonDetail>
        )}
      </S.ItemContent>
    </S.ItemContainer>
  );
};

export const GridCaveatTypes: React.FC<GridCaveatTypesProps> = ({
  caveatTypes = [],
}) => {
  const { getTranslation } = useTranslation(translations);
  return (
    <S.Container>
      <S.Header>
        <S.Label>Id</S.Label>
        <S.Label>{getTranslation("nome")}</S.Label>
      </S.Header>
      {caveatTypes.length > 0 &&
        caveatTypes.map((caveatType) => (
          <Item caveatType={caveatType} key={caveatType.id} />
        ))}
    </S.Container>
  );
};
